import React, { useEffect } from 'react';
import { GridItem } from '@tvg/fuse/grid';
import { ContentTileGroup } from '@tvg/fuse/content-tile-group';
import { ContentTile } from '@tvg/fuse/content-tile';
import { IconRestore, IconTakeThreeSmall, IconCalendarMonth } from '@tvg/fuse/icon/all';
import { isApp } from 'client/utils/utils';
import { useMainState } from 'client/state/Main';
import { EUserAction } from 'client/config';
import styles from './VeryPayWidgetContainer.module.css';

export interface VeryPayWidgetContainerProps {
  itemKey: number;
}
function VeryPayWidgetContainer({ itemKey }: VeryPayWidgetContainerProps) {
  const { lastAction, plpURL, firstCategory, firstURL, isHideVeryPayBanner, setIsHideVeryPayBanner } = useMainState(
    (state) => ({
      lastAction: state.lastAction,
      plpURL: state.plpURL,
      firstCategory: state.firstCategory,
      firstURL: state.firstURL,
      isHideVeryPayBanner: state.isHideVeryPayBanner,
      setIsHideVeryPayBanner: state.setIsHideVeryPayBanner,
    }),
  );
  useEffect(() => {
    // Early return: hide banner if no initial category is set but current page has a category
    if (!firstCategory && plpURL.category.id) {
      setIsHideVeryPayBanner(true);
      return;
    }

    const isCategoryAction = lastAction === EUserAction.CATEGORY;
    const isSameCategory = plpURL.category.id === firstCategory;
    const isValidFirstURLMatch =
      plpURL.pathname.includes(firstURL) &&
      (plpURL.pathname[firstURL.length] === '/' || plpURL.pathname[firstURL.length] === undefined);

    // Show banner if: same category OR valid first URL match
    if (isSameCategory || isValidFirstURLMatch) {
      setIsHideVeryPayBanner(false);
      return;
    }

    // Hide banner if: category action AND different category AND invalid first URL match
    if (isCategoryAction && !isSameCategory && !isValidFirstURLMatch) {
      setIsHideVeryPayBanner(true);
    }
  }, [lastAction, plpURL.category.id, plpURL.pathname, firstCategory, firstURL, setIsHideVeryPayBanner]);

  if (isApp() || isHideVeryPayBanner) return null;

  return (
    <GridItem id={`very-pay-widget-${itemKey}`} className={`${styles.veryPayWidget} veryPayWidget`} xxs={12}>
      <ContentTileGroup
        className="fuse-content-tile-group"
        dataAnalyticsId=""
        dataTestId="fuse-content-tile-group-data-test-id"
        link={{
          href: '/verypay.page',
          text: 'Find out more about Very Pay',
        }}
        representative="Representative 44.9% APR variable"
        title="More time to pay with Very Pay"
        titleTag="h2"
      >
        <ContentTile
          className={`${styles.contentTileItem} contentTileItem`}
          icon={<IconRestore />}
          label="Buy Now Pay Later"
          link="/bnpl.page"
        />
        <ContentTile
          className={`${styles.contentTileItem} contentTileItem`}
          icon={<IconTakeThreeSmall />}
          label="Pay in 3 with Take 3"
          link="/take3.page"
        />
        <ContentTile
          className={`${styles.contentTileItem} contentTileItem`}
          icon={<IconCalendarMonth />}
          label="Pay monthly"
          link="/paymonthly.page"
        />
      </ContentTileGroup>
    </GridItem>
  );
}

export default React.memo(VeryPayWidgetContainer);
